export const useColorScheme = () => {
    return 'light';
}